<template>
    <div class="picture_header_for_time_show">
        <div class="time_show_list">
            <div class="time_show_item" v-for="item in timeShowOfList" :key="item.key">
                <div :class="[item.type === 'list'? 'time_show_item_inner_item_for_time m_r2': 'time_show_item_inner_item_for_dot']" v-for="(v, k) in item.value" :key="k">
                    {{v}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        timeShowOfList: {
            type: Array,
            default: []
        }
    }
}
</script>

<style lang="scss" scoped>
@mixin verticalAndCrosswiseCenter {
    display: flex;
    justify-content: center;
    align-items: center;
}
.picture_header_for_time_show {
    .time_show_list {
        display: flex;
        color: #FFF;
        .time_show_item {
            display: flex;
            .time_show_item_inner_item_for_time {
                width: 16px;
                height: 24px;
                background-color: #000;
                border-radius: 2px;
                @include verticalAndCrosswiseCenter();
                font-size: 16px;
                color: #C1C1C1;
                font-weight: bold;
                padding-top: 2px;
            }
            .time_show_item_inner_item_for_time:nth-last-child(1) {
                margin-right: 0;
                margin-left: 2px;
            }
            .time_show_item_inner_item_for_dot {
                width: 9px;
                height: 24px;
                @include verticalAndCrosswiseCenter();
                font-size: 16px;
                color: #C1C1C1;
            }
        }
    }
}
</style>